import { Box, Grid, Typography } from '@mui/material';
import * as yup from 'yup';
import { useQueryClient } from 'react-query';
import {
  SparkForm,
  SparkFormImageUploader,
  SparkTextField,
  SparkBasicFormFooter,
} from 'sharedComponents/SparkForm';
import { getInitialStringValue } from 'utilities/form';
import { useUpdateWorkSpace } from 'hooks/Workspace/useUpdateWorkSpace';
import { Workspace } from 'types/Workspace';
import { useResize } from 'hooks/common';
import { PersonalOverview } from 'types/PersonalOverview/personalOverview';

type EditPersonalInfoFromSettingsValues = {
  image: string;
  name: string;
  description: string;
};

const validationSchema = yup.object({
  image: yup.string(),
  name: yup.string().required('Required'),
  description: yup.string().required('Required'),
});

type EditPersonalOverViewWorkSpaceFormProps = {
  workspace: Workspace | undefined;
};

const EditPersonalOverViewWorkSpaceForm = ({
  workspace,
}: EditPersonalOverViewWorkSpaceFormProps) => {
  const { mutateAsync: updateWorkspace } = useUpdateWorkSpace(workspace?.id);

  const initialValues = {
    image: getInitialStringValue(workspace?.attributes?.imageURL),
    name: getInitialStringValue(workspace?.attributes?.name),
    description: getInitialStringValue(workspace?.attributes?.description),
  };

  const handleSubmitCompanyInfo = async (
    values: EditPersonalInfoFromSettingsValues
  ) => {
    const { name, description, image } = values || {};
    await updateWorkspace({ name, description, imageURL: image });
  };

  const onImageUpload = async (imageURL: string) => {
    await updateWorkspace({ imageURL });
  };

  return (
    <Grid container>
      <Typography
        variant='h5'
        sx={{
          fontFamily: 'Mont-semibold',
        }}
      >
        Workspace Info
      </Typography>
      <Box
        width='100%'
        bgcolor='white'
        borderRadius='20px'
        border={(theme) => `1px solid ${theme.palette.borderColor}`}
      >
        <SparkForm<EditPersonalInfoFromSettingsValues>
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSave={handleSubmitCompanyInfo}
          containerProps={{ padding: 2, spacing: 2 }}
        >
          <SparkFormImageUploader
            name='image'
            containerName={workspace?.attributes.containerName}
            onUpload={onImageUpload}
          />
          <SparkTextField
            name='name'
            label='Workspace Name'
            placeholder='Enter Your Workspace Name'
          />

          <SparkTextField
            name='description'
            label='Description'
            placeholder='Enter Your Workspace Description'
          />

          <SparkBasicFormFooter
            shouldRenderResetButton={true}
            primaryButtonStyles={{ width: '200px' }}
            resetButtonStyles={{ width: '200px' }}
            resetButtonText='Cancel'
          />
        </SparkForm>
      </Box>
    </Grid>
  );
};

export default EditPersonalOverViewWorkSpaceForm;
